import { PathAnnotation } from '@readcloud/data';
import React from 'react';
import { DrawCanvas } from '../DrawCanvas';

export function PathAnnotationDrawer(props: {
  height: number;
  width: number;
  scale: number;
  annotation: PathAnnotation;
  onChange: (anno: PathAnnotation) => void;
}) {
  const handlePathsChange = React.useCallback<
    React.ComponentProps<typeof DrawCanvas>['onPathsChange']
  >(
    (paths) => {
      props.onChange({
        ...props.annotation,
        data: {
          ...props.annotation.data,
          paths,
        },
      });
    },
    [props.onChange, props.annotation]
  );

  return (
    <DrawCanvas
      scale={props.scale}
      stroke={props.annotation.data.stroke}
      strokeWidth={props.annotation.data.strokeWidth}
      onPathsChange={handlePathsChange}
      paths={props.annotation.data.paths}
      height={props.height}
      width={props.width}
    />
  );
}
